import ClinicalMilestone from '@model/ClinicalMilestone'
import ListTransform from '@model/list/ListTransform'
import Locale from '@serv/Locale'

class ListTransformSurveyCompletionStatus extends ListTransform {
    constructor(object) {
        super(object)
    }

    get getFilterComponent() {
        return 'DataFilterString'
    }

    get getFilterConfig() {
        return {
            title: Locale.getLanguageItem(this.column.label),
            valueLabels: [
                {
                    value: ClinicalMilestone.Status.complete,
                    label: Locale.getLanguageItem('clinicalMilestoneStatusSummaryComplete')
                },
                {
                    value: ClinicalMilestone.Status.pending,
                    label: Locale.getLanguageItem('clinicalMilestoneStatusSummaryPending')
                }
            ],
            addAll: true
        }
    }

    getQueryParamValueFromKeyStrings(keyStrings) {
        return { values: keyStrings }
    }
}

export default ListTransformSurveyCompletionStatus
